<template>
  <v-container grid-list-xs>
    <v-row v-if="requestingApi">
      <v-col cols="12">
        <v-progress-linear
                           class="mb-2"
                           indeterminate
                           color="yellow-darken-2"></v-progress-linear>
      </v-col>
      <v-col cols="12" class="text-center">
        <p class="text-h5">Preparando informações para o pagamento...</p>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-tabs v-model="tabSteps" color="primary" grow>
        <v-tab :value="1">
          <v-badge
                   v-if="tabSteps <= 1"
                   :color="tabSteps == 1 ? 'primary' : 'grey'"
                   content="1"
                   inline></v-badge>
          <v-icon v-else color="green">mdi-check</v-icon>
        </v-tab>
        <v-tab :value="2">
          <v-badge
                   v-if="tabSteps <= 2"
                   :color="tabSteps == 2 ? 'primary' : 'grey'"
                   content="2"
                   inline></v-badge>
          <v-icon v-else color="green">mdi-check</v-icon>
        </v-tab>
        <v-tab :value="3">
          <v-badge
                   v-if="tabSteps <= 3"
                   :color="tabSteps == 3 ? 'primary' : 'grey'"
                   content="3"
                   inline></v-badge>
          <v-icon v-else color="green">mdi-check</v-icon>
        </v-tab>
      </v-tabs>
      <v-col cols="12">
        <v-window v-model="tabSteps">
          <v-window-item :value="1">
            <v-row>
              <v-col cols="12">
                <AutocompleteSelectPaymentMethod
                                                 v-model="paymentMethod"
                                                 :user="user"
                                                 label="Selecione a forma de pagamento"
                                                 :returnObject="true"
                                                 :onlineOnly="true"
                                                 :restrictedTypes="restrictedTypes"
                                                 :selectedId="selectedPaymentMethodId"
                                                 :dueAmount="Number(checkout?.due_amount) || 0" />
              </v-col>
              <v-col v-if="tabSteps < 3 && !waitingValidation && !receipt" cols="6" class="text-left">
                <p>Valor dos lançamentos: {{ $filters.currency(checkout?.due_amount || 0, "BRL") }}</p>
              </v-col>
            </v-row>
          </v-window-item>
          <v-window-item :value="2">
            <v-row v-if="isPix">
              <v-col cols="4"></v-col>
              <v-col cols="4" v-if="!!pixImageData">
                <v-img :src="'data:image/jpeg;base64,' + pixImageData"
                       width="75%"
                       inline></v-img>
              </v-col>
              <v-col cols="4"></v-col>
              <v-col cols="2"></v-col>
              <v-col cols="7" v-if="!!pixStringData">
                <v-textarea :model-value="pixStringData"
                            variant="outlined"
                            label="Pix Copia/Cola"
                            rows="4"
                            row-height="10"
                            no-resize
                            readonly
                            shaped
                            prepend-inner-icon="mdi-whatsapp"
                            @click:prependInner="sendPixCopyPaste"
                            append-inner-icon="mdi-content-copy"
                            @click:appendInner="copyPixToClipboard">
                </v-textarea>
              </v-col>
            </v-row>
            <v-row v-if="isCard">
              <v-col cols="12">
                <p>Inserir dados do cartão</p>
              </v-col>
              <v-col cols="12">
                <FormCredicCard :user="user" v-model="creditCard" />
              </v-col>
              <v-col cols="12" class="text-right">
                <v-btn :disabled="requestingApi" @click="createBillingAgreement" color="success">Efetuar pagamento</v-btn>
              </v-col>
            </v-row>
          </v-window-item>
          <v-window-item :value="3">
            <v-row>
              <v-col cols="12" class="text-right">
                <v-btn color="green" size="small"
                       @click="$router.push({ name: 'MyInvoices', query: { it: 'paidInvoices' } })">
                  <v-icon class="mr-2">mdi-check</v-icon>
                  Minhas Contas Pagas
                </v-btn>
              </v-col>
              <v-col cols="12">
                <CheckoutReceipt :checkout="checkout" />
              </v-col>
            </v-row>
          </v-window-item>
        </v-window>
      </v-col>
      <v-col cols="8" class="text-right">
        {{ paymentMessage }}
      </v-col>
      <v-col v-if="tabSteps < 3 && !waitingValidation && !receipt" cols="4" class="text-right">
        <v-btn color="red" variant="text" size="small" @click="cancelCheckout">
          <v-icon class="mr-2">mdi-cancel</v-icon>
          Cancelar pagamento
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { markRaw } from "vue";
import AutocompleteSelectPaymentMethod from "../components/AutocompleteSelectPaymentMethod.vue";
import FormCredicCard from "../components/FormCredicCard.vue";
import CheckoutReceipt from "../components/CheckoutReceipt.vue";
import api from '@/services'

export default {
  components: {
    FormCredicCard,
    AutocompleteSelectPaymentMethod,
    CheckoutReceipt,
  },
  props: {
    user: Object
  },
  data() {
    return {
      requestingApi: false,
      sendingMessage: false,
      creditCard: {
        name: '',
        brand: '',
        cardHolder: '',
        cardNumber: '',
        expirationDate: '',
        cvv: ''
      },
      qrCodeString: null,
      qrCodeImage: null,
      paymentMethod: null,
      restrictedTypes: [],
      selectedPaymentMethodId: null,
      checkout: null,
      prePaymentData: null,
      checkTimeout: null,
      paymentStream: null,
      usingPollFallback: false,
      processingPayment: false,
      paymentComplete: false,
      checkingPayment: false,
      waitingValidation: false,
      paymentMessage: "",
      receipt: null,
      tabSteps: 1,
    };
  },
  created() { },
  mounted() { },
  activated() {
    var vm = this;

    vm.validateCheckout();
  },
  destroyed() {
    const vm = this;

    api.abortController.abort();
    vm.stopPaymentWatch();
    vm.resetCheckout();
  },
  methods: {
    stopPaymentWatch() {
      const vm = this;

      if (vm.paymentStream) {
        try {
          vm.paymentStream.close();
        } catch (_) { /* ignore */ }
        vm.paymentStream = null;
      }
      if (vm.checkTimeout) {
        clearTimeout(vm.checkTimeout);
        vm.checkTimeout = null;
      }
      vm.usingPollFallback = false;
    },
    startPaymentWatch() {
      const vm = this;

      if (!vm.checkout?.id || !vm.processingPayment) {
        return;
      }
      vm.stopPaymentWatch();
      vm.startPaymentStream();
    },
    startPaymentStream() {
      const vm = this;
      const checkoutId = vm.checkout?.id;

      if (!checkoutId || typeof EventSource === 'undefined') {
        vm.usingPollFallback = true;
        vm.checkPayment();
        return;
      }

      try {
        const url = api.checkout.streamUrl
          ? api.checkout.streamUrl(checkoutId)
          : `${import.meta.env.VITE_API_BASE_URL}/checkout/${checkoutId}/stream?timeout=300&interval_ms=1000`;
        // markRaw: EventSource must not be deeply reactive (breaks identity checks)
        const es = markRaw(new EventSource(url, { withCredentials: true }));
        vm.paymentStream = es;

        es.addEventListener('checkout.status', (e) => {
          let data = null;
          try {
            data = JSON.parse(e.data);
          } catch (_) {
            return;
          }
          vm.handlePaymentStatus(data, { fromStream: true });
        });

        es.addEventListener('done', () => {
          vm.stopPaymentWatch();
        });

        es.addEventListener('error', (e) => {
          // Named SSE event from API (e.g. checkout not found) — terminal
          if (e?.data) {
            try {
              const data = JSON.parse(e.data);
              vm.paymentMessage = data?.message || 'Erro no acompanhamento do pagamento';
              vm.processingPayment = false;
              vm.stopPaymentWatch();
              return;
            } catch (_) { /* fall through to connection handling */ }
          }
        });

        es.onerror = () => {
          // Network / auth / CORS — fall back to checkPayment poll
          if (vm.paymentStream) {
            vm.fallbackToPoll();
          }
        };
      } catch (_) {
        vm.usingPollFallback = true;
        vm.checkPayment();
      }
    },
    fallbackToPoll() {
      const vm = this;
      const hadStream = !!vm.paymentStream;

      if (vm.paymentStream) {
        try {
          vm.paymentStream.close();
        } catch (_) { /* ignore */ }
        vm.paymentStream = null;
      }
      if (!vm.processingPayment || vm.paymentComplete) {
        return;
      }
      // Already in poll mode without an active stream: avoid stacking loops
      if (vm.usingPollFallback && !hadStream) {
        return;
      }
      vm.usingPollFallback = true;
      if (!vm.checkingPayment) {
        vm.checkPayment();
      }
    },
    handlePaymentStatus(result, { fromStream = false } = {}) {
      const vm = this;

      if (!result) return;

      if (result.success) {
        vm.paymentMessage = result.message || 'Pagamento Efetuado com Sucesso!';
        vm.paymentComplete = true;
        vm.tabSteps = 3;
        vm.processingPayment = false;
        vm.getReceipt();
        vm.stopPaymentWatch();
        return;
      }

      if (result.error) {
        vm.paymentMessage = result.message || 'Pagamento cancelado.';
        vm.processingPayment = false;
        vm.stopPaymentWatch();
        return;
      }

      if (result.message) {
        vm.paymentMessage = result.message;
      }

      // active waiting: SSE keeps the connection; poll reschedules below
      if (fromStream) {
        return;
      }
    },
    validateCheckout() {
      var vm = this;
      let _checkoutId = vm.$route.query.checkout || null;

      if (vm.$route.query.payment_method_id && !isNaN(vm.$route.query.payment_method_id)) {
        vm.selectedPaymentMethodId = +vm.$route.query.payment_method_id;
      }
      if (_checkoutId) {
        vm.requestingApi = true;
        api.checkout
          .getPending(_checkoutId)
          .then((result) => {
            let _checkoutData = result || null;

            if (_checkoutData?.status === vm.$CHECKOUT_STATUS_DIC.PENDING.value) {
              vm.resetCheckout();
            }
            if (_checkoutData.invoices.some(i => i.from?.group_id === 777)) {
              vm.restrictedTypes = [2];
            }
            vm.checkout = _checkoutData;
            vm.prePaymentData = _checkoutData?.initiate_data || null;
            // Não precisa colocar o step pois ao alterar o paymentMethod, o step 2 é chamado através do watch
            // vm.tabSteps = 2;
            // vm.processingPayment = true;
            
            if (vm?.checkout?.payment_method_id) {
              vm.selectedPaymentMethodId = +vm?.checkout.payment_method_id;
            }
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
            vm.$router.push({ name: "MyInvoices" });
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      } else {
        vm.resetCheckout();
      }
    },
    resetCheckout() {
      const vm = this;

      vm.stopPaymentWatch();
      vm.paymentMessage = "";
      vm.tabSteps = 1;
      vm.receipt = null;
      vm.paymentMethod = null;
      vm.checkout = null;
      vm.prePaymentData = null;
      vm.billingAgreement = null;
      vm.paymentComplete = false;
      vm.processingPayment = false;
      vm.checkingPayment = false;
      vm.waitingValidation = false;
      vm.creditCard = {
        name: '',
        brand: '',
        cardHolder: '',
        cardNumber: '',
        expirationDate: '',
        cvv: ''
      };
    },
    prePayment() {
      const vm = this;

      if (!vm.requestingApi) {
        vm.requestingApi = true;
        api.checkout
          .prePayment({ paymentMethodId: vm.paymentMethod?.id })
          .then((result) => {
            vm.prePaymentData = result;
            vm.tabSteps = 2;
            vm.processingPayment = true;
            vm.startPaymentWatch();
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      }
    },
    createBillingAgreement() {
      var vm = this;

      vm.requestingApi = true;
      api.billingAgreement
        .create({
          name: vm.creditCard.name,
          type: vm.paymentMethod.type,
          cardNumber: vm.creditCard.cardNumber,
          holder: vm.creditCard.cardHolder,
          expirationDate: vm.creditCard.expirationDate,
          securityCode: vm.creditCard.cvv,
          brand: vm.creditCard.brand,
          payment_method_id: vm.paymentMethod.id,
        })
        .then((result) => {
          let _billingAgreement = result || null;

          vm.billingAgreement = _billingAgreement;
          vm.processingPayment = true;
          vm.pay();
        })
        .catch((err) => {
          if (err.message) {
            vm.$notify({
              type: "warn",
              text: err.message,
            });
          }
          vm.requestingApi = false;
        });
    },
    pay() {
      var vm = this;

      vm.requestingApi = true;
      api.checkout
        .pay({
          cardNumber: vm.creditCard.cardNumber,
          holder: vm.creditCard.cardHolder,
          expirationDate: vm.creditCard.expirationDate,
          securityCode: vm.creditCard.cvv,
          brand: vm.creditCard.brand,
          paymentMethodId: vm.paymentMethod?.id
        })
        .then((result) => {
          let _paymentData = result?.data || {};

          vm.tabSteps = 3;
          vm.paymentComplete = true;
          vm.getReceipt();
        })
        .catch((err) => {
          if (err.message) {
            vm.$notify({
              type: "warn",
              text: err.message,
            });
            vm.paymentMessage = err.message;
          } else {
            vm.paymentMessage = "Erro no processamento, tente novamente!";
          }
        })
        .finally(() => {
          vm.requestingApi = false;
          vm.processingPayment = false;
        });
    },
    checkPayment() {
      const vm = this;

      if (!vm.checkingPayment && vm?.checkout) {
        vm.checkingPayment = true;
        return api.checkout
          .checkPayment(vm.checkout.id)
          .then((result) => {
            if (result?.success) {
              vm.handlePaymentStatus(result);
            } else if (result?.active) {
              if (result?.message) {
                vm.paymentMessage = result?.message;
              }
              if (vm.processingPayment) {
                const delay = vm.usingPollFallback ? 1500 : 1000;
                vm.checkTimeout = setTimeout(() => {
                  vm.checkPayment();
                }, delay);
              }
            } else {
              vm.paymentMessage = result?.message;
              if (result?.error) {
                vm.processingPayment = false;
              }
            }
            return result;
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
            // Retry poll while still waiting (e.g. transient network blip)
            if (vm.processingPayment && vm.usingPollFallback) {
              vm.checkTimeout = setTimeout(() => {
                vm.checkPayment();
              }, 1500);
            }
            return null;
          })
          .finally(() => {
            vm.checkingPayment = false;
          });
      }
      return Promise.resolve(null);
    },
    cancelCheckout() {
      var vm = this;

      vm.selectedPaymentMethodId = null;
      vm.stopPaymentWatch();
      // Must reset after abort — aborted signal would cancel this cancel request too
      if (typeof api.resetAbortController === 'function') {
        api.resetAbortController();
      } else {
        api.abortController.abort();
      }
      vm.requestingApi = true;
      api.checkout
        .cancel()
        .then((result) => {
          vm.resetCheckout();
          vm.$notify({
            type: "success",
            text: "Cancelado",
          });
          vm.$router.push({ name: "MyInvoices" });
        })
        .catch((err) => {
          const text =
            err?.response?.data?.message ||
            err?.message ||
            'Não foi possível cancelar. Se for PIX, aguarde o tempo mínimo e tente de novo.';
          vm.$notify({
            type: "warn",
            text,
          });
        })
        .finally(() => {
          vm.requestingApi = false;
        });
    },
    getReceipt() {
      const vm = this;

      vm.receipt = {
        message: "Sucesso! AQUI VAI O RECIBO"
      };
    },
    copyPixToClipboard() {
      const vm = this;

      navigator.clipboard.writeText(vm.pixStringData);
      vm.$notify({
        type: "success",
        text: "Copiado para a área de transferência",
      });
    },
    sendPixCopyPaste() {
      var vm = this;

      if (vm?.user?.legal_person?.notification_phone) {
        if (!vm.sendingMessage) {
          vm.sendingMessage = true;
          const data = {
            phoneNumber: vm.user.legal_person.notification_phone,
            text: vm.pixStringData,
          };
          return api.botConversa.sendMessage(data)
            .then((result) => {
              vm.$notify({
                type: "success",
                text: "Mensagem enviada",
              });
              return result;
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
              return null;
            })
            .finally(() => {
              vm.sendingMessage = false;
            });
        }
      } else {
        vm.$notify({
          type: "warn",
          text: "Telefone de Contato não Encontrado",
        });
      }
      return Promise.resolve(null);
    }
  },
  computed: {
    isPix() {
      const vm = this;

      return vm?.paymentMethod?.type == vm.$PAYMENT_METHOD_TYPES_DIC.PIX.value;
    },
    isCard() {
      const vm = this;

      return vm?.paymentMethod?.type == vm.$PAYMENT_METHOD_TYPES_DIC.CREDIT_CARD.value || vm.paymentMethod?.type == vm.$PAYMENT_METHOD_TYPES_DIC.DEBIT_CARD.value;
    },
    pixImageData() {
      const vm = this;

      return vm.prePaymentData?.Payment?.QrCodeBase64Image;
    },
    pixStringData() {
      const vm = this;

      return vm.prePaymentData?.Payment?.QrCodeString;
    }
  },
  watch: {
    paymentMethod(newVal) {
      const vm = this;

      if (newVal) {
        if (vm.checkout && vm.checkout.initiate_data) {
          vm.prePaymentData = vm.checkout.initiate_data;
          vm.tabSteps = 2;
          vm.processingPayment = true;
          vm.startPaymentWatch();
        } else {
          vm.prePayment();
        }
      } else {
        vm.prePaymentData = null
      }
    },
    tabSteps(newVal, oldVal) {
      var vm = this;

      switch (newVal) {
        case 2:
          if (!vm.paymentMethod || !vm.prePaymentData) {
            vm.tabSteps = oldVal;
          }
          break;
        case 3:
          if (!vm.paymentComplete) {
            vm.tabSteps = oldVal;
          } else if (!vm.receipt) {
            vm.getReceipt();
          }
          break;
      }
    },
  },
};
</script>